import Typography from "@mui/material/Typography";

import Alert from "@rui/Alert";
import { Row } from "@rui/Stack";

interface ReauthAlertProps<T> {
  onReauthClick: (id: T) => void;
  providerId: T;
}

const ReauthAlert = <T extends string>({
  onReauthClick,
  providerId,
}: ReauthAlertProps<T>) => (
  <Alert severity="error" sx={{ p: 1, px: 1 }}>
    <Row variant="left" spacing={0.5}>
      <Typography
        variant="bodySecondaryReg"
        sx={{ fontSize: "14px", color: "shades.neutral.600" }}
      >
        Reauthorization required.
      </Typography>
      <Typography
        variant="bodySecondaryMed"
        sx={{ cursor: "pointer", color: "shades.secondary.500" }}
        onClick={() => onReauthClick(providerId)}
      >
        Click to reauthorize.
      </Typography>
    </Row>
  </Alert>
);

export default ReauthAlert;
